'use client'
import { SupplierOffersAndEventsItem } from '@/components/v3/unique/supplier/supplier-offers-and-events/supplier-offers-and-events-item/supplier-offers-and-events-item'
import s from './supplier-offers-and-events.module.scss'
import { formatDateLabel } from '@/utils/offersAndEvents/formatDateLabel'
import { TabsV3 } from '@/components/v3/atoms/tabs/tabs'

export type Offer = {
  id: string
  link?: string
  title: string
  status: string
  endDate: string
  startDate: string
  description: string
}

export type Event = Offer

type Props = {
  offers: Offer[]
  events: Event[]
}

export const SupplierOffersAndEvents = ({ offers, events }: Props) => {  
  if (!offers.length && !events.length) return null

  return (
    <div className={s.container}>
      <h2 className={s.title}>Offers & Events</h2>
      <TabsV3
        tabs={[
          {
            id: 'offers',
            text: (
              <>
                Offers <span className={s.counter}>{offers.length}</span>
              </>
            ),
            content: offers.map((offer) => (
              <SupplierOffersAndEventsItem
                key={offer.id}
                title={offer.title}
                date={formatDateLabel(offer.startDate, offer.endDate)}
                description={offer.description}
                link={offer?.link}
              />
            )),
            hidden: offers.length === 0,
          },
          {
            id: 'events',
            text: (
              <>
                Events <span className={s.counter}>{events.length}</span>
              </>
            ),
            content: events.map((event) => (
              <SupplierOffersAndEventsItem
                key={event.id}
                title={event.title}
                date={formatDateLabel(event.startDate, event.endDate)}
                description={event.description}
                link={event?.link}
              />
            )),
            hidden: events.length === 0,
          },
        ]}
        defaultTab={offers.length > 0 ? 'offers' : 'events'}
      />
    </div>
  )
}
